<template>
  <div
    v-if="cartPositionsCount"
    class="header-cart-fi"
  >
    {{ cartPositionsCount }}
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';

import { useCartStore } from '@/store/pinia/cart';

defineOptions({ name: 'HeaderCartFi' });

const cartStore = useCartStore();
const cartPositionsCount = computed(() => cartStore.positionsCount);

onMounted(() => cartStore.refetchPositionsCount());
</script>

<style scoped src="./header-cart-fi" />
